import {GetterTree} from "vuex";
import {RootState} from "../../store";
import BrowserState from "./state";

const getters: GetterTree<BrowserState, RootState> = {

}

export default getters;
